import React from 'react';
export function AdvisorsSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-22">
      <div className="flex flex-col w-full h-full min-h-0 relative overflow-hidden justify-center" data-id="element-23">
        {/* Header */}
        <div className="flex-shrink-0 flex flex-col" style={{
        padding: '0 clamp(2rem, 6vw, 6rem)',
        marginBottom: 'clamp(1rem, 2vw, 1.5rem)'
      }} data-id="element-24">
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.2rem, 0.4vw, 0.35rem)',
          animationDelay: '0.1s'
        }} data-id="element-25">
            Key Equity advisors.
          </p>
          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          animationDelay: '0.15s'
        }} data-id="element-26">
            Advisors helping us pave the way.
          </h1>
        </div>

        {/* Screenshot */}
        <div className="flex-1 min-h-0 flex items-center justify-center animate-fade-slide" style={{
        padding: '0 clamp(2rem, 6vw, 6rem) clamp(1.5rem, 3vw, 2.5rem)',
        animationDelay: '0.25s'
      }} data-id="element-27">
          <img src="https://cdn.magicpatterns.com/uploads/dVZYzPXWzoPbJmje85V8ms/Screenshot_2026-03-23_at_1.25.02_PM.png" alt="Advisors — Sean Gorman (Snap Maps), Erin Clift (ex-CMO Waze/Google), Marco Herndon (San Francisco City Expert)" style={{
          width: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          borderRadius: 'clamp(8px, 1vw, 12px)'
        }} data-id="element-28" />
        </div>
      </div>
    </section>;
}